import { FormattedMessage } from 'react-intl';

import type { Props as ButtonProps } from '#src/atoms/buttons/Button/index.tsx';
import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { glossary } from '#src/lib/glossary.ts';

export interface Props extends Omit<ButtonProps, 'size'> {
  hasMore?: boolean;
  loading: boolean;
  loadMore: () => void;
}

export const LoadMoreButton = ({
  hasMore,
  loading,
  loadMore,
  ...rest
}: Props) => {
  if (!hasMore) return null;

  return (
    <Button
      loading={loading}
      color="tertiary"
      size="medium"
      disabled={loading}
      onClick={loadMore}
      {...rest}
    >
      <FormattedMessage {...glossary.loadMore} />
    </Button>
  );
};
